export default class RegisterPackagesSelector {
  public static selectIsLoading(state: ReduxState): boolean {
    return state.registerPackage.isLoading;
  }
}
